// removed by extract-text-webpack-plugin
module.exports = {"LogoutLogo":"Logout-module__LogoutLogo__2uU_L","LogoutWrapper":"Logout-module__LogoutWrapper__2JZ_6","LogoutInner":"Logout-module__LogoutInner__3h_8N","LogoutH1":"Logout-module__LogoutH1__3MrR0","LogoutP":"Logout-module__LogoutP__17p71","LogoutAdList":"Logout-module__LogoutAdList__o7RrF","buttonWrapper":"Logout-module__buttonWrapper__FmAJe","coverDiv":"Logout-module__coverDiv__9XyTO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logout/Logout.module.css
// module id = 1789
// module chunks = 31